import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { CookieService } from 'ngx-cookie-service';
// import { GtagModule } from 'angular-gtag';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//import {ExploreRoutingModule} from './private/pages/explore/explore-routing.module'
import { AuthHttpService } from './core/services/authorization/auth-http.service';
import { environment } from '../environments/environment';
import { GlobalService } from './core/services/global.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { reducers } from './store/app.reducers';
import { RootEffects } from './public/store/root-effects';
import { ConfirmationModalModule } from './core/components/confirmation-modal/confirmation-modal.module';
import { ModalModule } from './core/components/modal/modal.module';
import { ModalService } from './core/components/modal/modal.service';
import { AlertModule } from './core/components/alerts/alert.module';
import { FlexLayoutModule } from "@angular/flex-layout";
import { NgxPayPalModule } from 'ngx-paypal';
import { DashboardService } from './core/services/dashboard/dashboard.service';
import {DatePipe} from '@angular/common';
import { GtagModule } from 'angular-gtag';
import { NgxClarityModule } from 'ngx-clarity';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FlexLayoutModule,
        AppRoutingModule,
        AlertModule,
        ModalModule,
        ConfirmationModalModule,
        RouterModule,
        HttpClientModule,
       // ExploreRoutingModule,
        TranslateModule.forRoot(),
        EffectsModule.forRoot([RootEffects]),
        StoreModule.forRoot(reducers),
        !environment.production
            ? StoreDevtoolsModule.instrument({
                  maxAge: 20,
              })
            : [],
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        GtagModule.forRoot(environment.googleAnalyticsConfig),
        NgxPayPalModule,
        NgxClarityModule.forRoot({
            enabled: true,
            projectId: 'kwhucvwoly',
          }),
    
    ],
    declarations: [AppComponent],
    providers: [ModalService, CookieService, GlobalService, AuthHttpService, DashboardService,DatePipe],
    bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/public/', '.json');
}
